import React, { useState, useEffect, useRef } from 'react'
import { shuffle } from 'lodash'
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'

export default function ListComponent(props) {
  const {
    listData,
    x,
    y,
    onValueChange,
    defaultValue,
    isPractice,
    completed,
    isActive,
    width,
    height,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    outsideClick,
    handleOutSideClick,
    isVerifyMode,
    explanationClick,
    onExplanationVisible,
    handleSelectedItem,
    currentSelectedItem,
    handleSuccessChange,
    handleSucAndFailFeedback,
    isReadonly,
    isAudioPlaying
  } = props
  const {
    Data,
    ControlID,
    PluginId,
    Priority,
    SequenceHint,
    FontFamily,
    FontSize,
    FontColor,
    FillColor,
    DisplayType,
    Bold,
    Italic,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    FeedbackAudioData
  } = listData
  const [list, setList] = useState([])
  const [isCorrect, setisCorrect] = useState(false)
  const [priorityValue, setPriorityValue] = useState(0)
  const [correctAnswerWeight, setCorrectAnswerWeight] = useState(0)
  const [correctAnswer, setCorrectAnswer] = useState('')
  const [dropdownVisible, setDropdownVisible] = useState(false)
  let yInt = parseFloat(y.split('%')[0])
  const [failureCount, setFailureCount] = useState(0)

  useEffect(() => {
    Data.map((item, index) => {
      if (parseFloat(item.Value) > correctAnswerWeight) {
        setCorrectAnswerWeight(parseFloat(item.Value))
        setCorrectAnswer(item.Answer)
      }
    })
  }, [])

  useEffect(() => {
    const shuffledArray = shuffle(Data)
    setList(shuffledArray)
  }, [Data])

  useEffect(() => {
    handleSelectedItem(undefined)
  }, [outsideClick])

  useEffect(() => {
    setPriorityValue(currentPriority)
  }, [currentPriority])

  useEffect(() => {
    if (list.length > 0) {
      let weight = list.find((item) => item.Answer === defaultValue.Answer)
      if (weight && parseFloat(weight.Value) > 0) {
        setisCorrect(true)
      } else {
        setisCorrect(false)
      }
    }
  }, [list])

  //Failure message Sequence
  function handleFailureFeedback() {
    let feedbackAudioData = FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        setFailureCount(1)
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        setFailureCount(2)
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }

    handleSucAndFailFeedback(false, failureFeedback)
  }

  function validateAndUpdate(Answer) {
    setDropdownVisible(false)
    handleOutSideClick(true)

    if (Answer.toLowerCase() !== 'select') {
      let weight = list.find((item) => item.Answer === Answer)
      onValueChange(weight, ControlID)
      if (followTheFlow) {
        if (isPractice) {
          if (parseFloat(weight.Value) > 0) {
            setisCorrect(true)
            // handleSuccessChange(true)
            // handleSucAndFailFeedback(true)
            handleSucAndFailFeedback(true, FeedbackAudioData.successData)
          } else {
            setisCorrect(false)
            // handleSuccessChange(false)
            // handleSucAndFailFeedback(false)
            handleFailureFeedback()
          }
        } else {
          onPriorityChange(Priority)
        }
      }
    }
  }

  function renderDropdownUI() {
    return (
      <div
        className='dropdown-content card-shadow'
        style={{
          width: '100%',
          minWidth: '10%',
          height: 'fit-content',
          maxHeight: '150px',
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          border: '1px solid #B5B5B5',
          borderRadius: '4px',
          bottom: yInt > 70 ? '100%' : undefined,
          marginTop: yInt > 70 ? undefined : '5%',
          position: 'absolute'
        }}
      >
        {list.map((l, index) => (
          <span
            className='dropdown-list-label-container'
            style={{
              fontFamily: FontFamily,
              color: FontColor,
              fontStyle: Italic ? 'italic' : 'normal',
              fontWeight: Bold ? 'bold' : 'normal',
              fontSize:
                FontSize && FontSize === 'SMALL'
                  ? SMALL_DESKTOP
                  : FontSize === 'LARGE'
                  ? LARGE_DESKTOP
                  : MEDIUM_DESKTOP,
              cursor: 'pointer'
            }}
            key={index.toString()}
            onClick={(ev) => {
              ev.preventDefault()
              validateAndUpdate(l.Answer)
            }}
          >
            {PluginId === 'AGTextList' ? (
              <p className='dropdown-list-label'>{l.Answer}</p>
            ) : DisplayType === 'inktotext' ? (
              <InlineMath>{l.Answer}</InlineMath>
            ) : (
              <img
                src={l.Answer}
                alt='op'
                style={{
                  width: '100%',
                  height: '50px',
                  objectFit: 'contain'
                }}
              />
            )}
          </span>
        ))}
      </div>
    )
  }

  return (
    <div
      style={{
        left: x,
        top: y,
        width: width + '%',
        height: height + '%',
        position: 'absolute',
        cursor: 'pointer',
        filter: followTheFlow
          ? Priority <= currentPriority
            ? 'unset'
            : 'blur(3px)'
          : 'unset',
        pointerEvents:
          completed === 1 || !isActive || isAudioPlaying
            ? 'none'
            : followTheFlow
            ? isPractice
              ? Priority === currentPriority
                ? 'auto'
                : 'none'
              : Priority > currentPriority
              ? 'none'
              : 'auto'
            : 'auto',
        zIndex:
          currentSelectedItem.current &&
          currentSelectedItem.current === ControlID
            ? 8
            : 5,
        fontSize:
          FontSize === 'SMALL'
            ? SMALL_DESKTOP
            : FontSize === 'LARGE'
            ? LARGE_DESKTOP
            : MEDIUM_DESKTOP,
        fontFamily: FontFamily,
        color: FontColor,
        fontStyle: listData.Italic ? 'italic' : 'normal',
        fontWeight: listData.Bold ? 'bold' : 'normal',
        backgroundColor: priorityValue === Priority ? '#FFFFFF' : FillColor,
        borderRadius: '4px',
        border:
          isPractice || completed === 1 || !isActive
            ? defaultValue !== ''
              ? isCorrect
                ? '2px solid #3EC986'
                : '2px solid #ff551f'
              : '2px solid #b5b5b5'
            : '2px solid #b5b5b5'
      }}
      onClick={(ev) => {
        ev.preventDefault()
        // Answer Explanation
        if (explanationClick) {
          if (isCorrect) {
            onExplanationVisible(true, CorrectAnswerExplanation)
          } else {
            onExplanationVisible(false, IncorrectAnswerExplanation)
          }
        } else {
          if (isPractice && followTheFlow) {
            if (isCorrect) {
            } else {
              if (
                currentSelectedItem.current &&
                currentSelectedItem.current === ControlID
              ) {
                currentSelectedItem.current = undefined
                setDropdownVisible(false)
              } else {
                if (dropdownVisible) {
                  setDropdownVisible(false)
                  handleOutSideClick(true)
                } else {
                  handleSelectedItem(ControlID)
                  setDropdownVisible(true)
                }
              }
            }
          } else {
            if (
              currentSelectedItem.current &&
              currentSelectedItem.current === ControlID
            ) {
              currentSelectedItem.current = undefined
              setDropdownVisible(false)
            } else {
              if (dropdownVisible) {
                setDropdownVisible(false)
                handleOutSideClick(true)
              } else {
                handleSelectedItem(ControlID)
                setDropdownVisible(true)
              }
            }
          }
        }
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            width: '90%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: '2%',
            overflow: 'hidden'
          }}
        >
          {PluginId === 'AGTextList' ? (
            <p
              style={{
                width: '100%',
                color: FontColor,
                fontWeight: listData.Bold ? 'bold' : 'normal',
                margin: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden'
              }}
            >
              {isVerifyMode ? correctAnswer : defaultValue.Answer}
            </p>
          ) : DisplayType === 'inktotext' ? (
            defaultValue.Answer ? (
              <InlineMath>
                {isVerifyMode ? correctAnswer : defaultValue.Answer}
              </InlineMath>
            ) : (
              <span />
            )
          ) : defaultValue.Answer ? (
            <img
              src={isVerifyMode ? correctAnswer : defaultValue.Answer}
              alt='op'
              style={{
                width: '100%',
                height: '50px',
                objectFit: 'contain'
              }}
            />
          ) : (
            <span />
          )}
        </div>
        <div style={{ width: '10%', height: '100%', display: 'contents' }}>
          <ArrowDropDownIcon
            style={{
              width: '30px',
              height: '30px',
              alignSelf: 'center',
              color: '#A8A8A8'
            }}
          />
        </div>
      </div>

      {currentSelectedItem.current &&
        currentSelectedItem.current === ControlID &&
        renderDropdownUI()}
    </div>
  )
}
